import React from 'react';
import './Chooseplasticbottl.css';
import chooplast from '../../../imgs/chooplastic.webp';

const Chooseplasticbottl = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">How to Choose Plastic Bottle Caps Production Equipment?</h2>
                <p className="Cavity-date">Oct. 18, 2022</p>
                <div className="Ordinary">
                    <img src={chooplast} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <div className="Ordinary-content">

                    <p className="Ordinary-text">There are two main types of plastic bottle cap production equipment:
                        compression molding machines and injection molding machines,
                        each with its own advantages and disadvantages.</p>

                    <h2 className="">Compression Molding Machines</h2>
                    <p>Advantages:</p>
                    <ul className="Ordinary-text">
                        <li>High production efficiency</li>
                        <li>Better visual appearance by avoiding gate marks</li>
                        <li>Easy to maintain molds</li>

                    </ul>
                    <p>Disadvantages:</p>
                    <ul className="Ordinary-text">
                        <li>Single function, only ordinary caps can be produced</li>
                        <li>Finished plastic bottle caps cannot be produced at one time</li>
                        <li>Secondary processing may be required after compression molding</li>

                    </ul>
                </div>

            </div>

        </div>
    );
};

export default Chooseplasticbottl;
